import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Responsive from 'datatables.net-responsive';
import AreaChart from '../components/charts/AreaChart';
import CircleProgress from '../components/charts/CircleProgress';
import MobileFooter from '../components/MobileFooter';

DataTable.use(DT);
DataTable.use(Responsive);

const JobPortal: React.FC = () => {
    const [dtApi, setDtApi] = useState<any>(null);

    const options = useMemo(() => ({
        responsive: true,
        pageLength: 6,
        lengthChange: false,
        searching: true,
        dom: 'rtip',
        initComplete: (settings: any) => {
            const api = new DT.Api(settings);
            setDtApi(api);
        }
    }), []);

    const jobsData = useMemo(() => [
        {
            title: 'Senior Frontend Developer',
            location: 'AL, USA',
            company: 'TechNova Solutions',
            experience: '5-8 Years',
            postingDate: '2026-10-25',
            lastDate: '2026-11-20',
            status: 'Active',
            statusClass: 'theme-green',
            applicants: '124 Applied',
            isFavorite: true
        },
        {
            title: 'Product Manager',
            location: 'LA, USA',
            company: 'Global Innovations Inc.',
            experience: '3-5 Years',
            postingDate: '2026-11-01',
            lastDate: '2026-12-15',
            status: 'Inactive',
            statusClass: 'theme-red',
            applicants: '48 Applied',
            isFavorite: false
        },
        {
            title: 'AI/ML Research Scientist',
            location: 'London, UK',
            company: 'FutureMinds AI',
            experience: '10+ Years',
            postingDate: '2026-09-15',
            lastDate: '2026-11-10',
            status: 'Inactive',
            statusClass: 'theme-red',
            applicants: '150 Applied',
            isFavorite: true
        },
        {
            title: 'Junior Data Analyst',
            location: 'CA, CA',
            company: 'DataStream LLC',
            experience: '0-2 Years',
            postingDate: '2026-11-10',
            lastDate: '2026-12-30',
            status: 'Active',
            statusClass: 'theme-green',
            applicants: '249 Applied',
            isFavorite: false
        },
        {
            title: 'UX Designer',
            location: 'Mu, IN',
            company: 'Creative Hub',
            experience: '2-4 Years',
            postingDate: '2026-11-05',
            lastDate: '2026-12-05',
            status: 'Active',
            statusClass: 'theme-green',
            applicants: '77 Applied',
            isFavorite: false
        },
        {
            title: 'AI/ML Research Scientist',
            location: 'London, UK',
            company: 'FutureMinds AI',
            experience: '10+ Years',
            postingDate: '2026-09-15',
            lastDate: '2026-11-10',
            status: 'Active',
            statusClass: 'theme-green',
            applicants: '150 Applied',
            isFavorite: false
        },
        {
            title: 'Junior Data Analyst',
            location: 'London, UK',
            company: 'DataStream LLC',
            experience: '0-2 Years',
            postingDate: '2026-11-10',
            lastDate: '2026-12-30',
            status: 'Active',
            statusClass: 'theme-green',
            applicants: '249 Applied',
            isFavorite: false
        },
        {
            title: 'UX Designer',
            location: 'London, UK',
            company: 'Creative Hub',
            experience: '2-4 Years',
            postingDate: '2026-11-05',
            lastDate: '2026-12-05',
            status: 'Active',
            statusClass: 'theme-green',
            applicants: '77 Applied',
            isFavorite: false
        }
    ], []);

    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row gx-3 gx-lg-4 align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Job Portal</h6>
                        <p className="text-secondary small">Find, Manage Jobs and Employers</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Job Portal</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="card bg-theme-r-gradient mb-3 mb-lg-4">
                    <div className="card-body">
                        <div className="row gx-3 gx-lg-4">
                            <div className="col-12 col-md-9 col-lg-8 px-2 px-lg-4 align-self-center">
                                <p>Meet the Best, Save the Time</p>
                                <h1 className="">Manage your client<br />at one place</h1>
                                <p className="opacity-75">Add more than 50 Clients by upgrading your plan.<br />You have reached at your maximum limit of client connection.</p>
                                <button className="btn btn-accent">Upgrade Plan</button>
                            </div>
                            <div className="col-12 col-md-3 col-lg-4 d-none d-md-flex">
                                <img src="assets/img/adminuiux/jobbanner.png" alt="" className="mt-3 width-200" />
                            </div>
                        </div>
                    </div>
                    <div className="card-footer bg-theme-1-subtle border-top border-theme-1">
                        <div className="row gx-3 gx-lg-4 align-items-center">
                            <div className="col-12 col-md-auto mb-3 mb-md-0">
                                <p>Find a Job</p>
                            </div>
                            <div className="col-12 col-md mb-3 mb-md-0">
                                <input type="text" className="form-control" placeholder="Search for Position, Job Id etc." />
                            </div>
                            <div className="col-12 col-md-auto mb-3 mb-md-0">
                                <select className="form-select">
                                    <option value="">Select Company</option>
                                    <option value="">Alembica</option>
                                    <option value="">Adminuiux</option>
                                    <option value="">CoreUI Trends</option>
                                </select>
                            </div>
                            <div className="col-12 col-md-auto">
                                <button className="btn btn-accent w-100 w-md-auto">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* alert */}
                <div className="alert alert-warning alert-dismissible fade show mb-3 mb-lg-4">
                    <button type="button" className="btn-close" data-bs-dismiss="alert">
                    </button>
                    <h6 className="text-dark">Apply | New Jobs Opening</h6>
                    <p className="text-secondary small">Recuitement group has new large scale mega jobs fair. Apply all at one click and Get a chance to visit on-site and event participation by applying this job group</p>
                    <div className="row gx-3 gx-lg-4">
                        <div className="col-12 col-sm mb-3 mb-lg-0">
                            <p className="small"><span className="text-secondary">Last day of application:</span><br /> Thursday, 10-5-2019</p>
                        </div>
                        <div className="col-12 col-sm-auto align-self-center">
                            <figure className="avatar avatar-30 coverimg rounded-circle me-2"><img src="assets/img/adminuiux/user-1.jpg" alt="" /></figure>
                            <figure className="avatar avatar-30 coverimg rounded-circle me-2"><img src="assets/img/adminuiux/user-6.jpg" alt="" /></figure>
                            <figure className="avatar avatar-30 coverimg rounded-circle me-2"><img src="assets/img/adminuiux/user-9.jpg" alt="" /></figure>
                            <button className="btn btn-sm btn-theme">Apply</button>
                        </div>
                    </div>
                </div>
                {/* summary blocks */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col-auto theme-blue">
                                        <CircleProgress percentage={70} color="#3dbff3" size={60} fillText={true} />
                                    </div>
                                    <div className="col-12 col-md mt-3 mt-md-0">
                                        <p className="text-secondary small mb-2">New Jobs</p>
                                        <h4 className="mb-1">1530</h4>
                                        <p className="text-theme-1 small theme-green"><i className="bi bi-caret-up-fill"></i> 12%</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col-auto theme-green">
                                        <CircleProgress percentage={55} color="#00c851" size={60} fillText={true} />
                                    </div>
                                    <div className="col-12 col-md mt-3 mt-md-0">
                                        <p className="text-secondary small mb-2">New Clients</p>
                                        <h4 className="mb-1">175</h4>
                                        <p className="text-red text-theme-1 small"><i className="bi bi-caret-up-fill"></i> - 50 Jobs</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col-auto theme-yellow">
                                        <CircleProgress percentage={80} color="#ffc107" size={60} fillText={true} />
                                    </div>
                                    <div className="col-12 col-md mt-3 mt-md-0">
                                        <p className="text-secondary small mb-2">New Users</p>
                                        <h4 className="mb-1">154</h4>
                                        <p className="text-theme-1 small theme-green"><i className="bi bi-caret-up-fill"></i> +22 Users</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card bg-theme-1 mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col-auto theme-white">
                                        <CircleProgress percentage={90} color="#ffffff" size={60} fillText={true} />
                                    </div>
                                    <div className="col-12 col-md mt-3 mt-md-0">
                                        <p className="opacity-75 small mb-2">Jobs Applied</p>
                                        <h4 className="mb-1">1542</h4>
                                        <p className="text-theme-1 small theme-green"><i className="bi bi-caret-up-fill"></i> +2012 Applied</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* jobs analytics */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-lg-9">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-1">Jobs Analytics</h6>
                                        <p className="text-secondary small">Informations are provided based on complete job cycle </p>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-sm btn-theme-1" data-bs-toggle="tooltip" title="Download"><i className="bi bi-download"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <AreaChart labels={['1', '2', '3', '4', '5', '7', '8', '9', '10']}
                                    datasets={[
                                        {
                                            data: [15, 10, 20, 15, 25, 20, 15, 10, 30, 15],
                                            label: 'Jobs',
                                            color: '#3dbff3',
                                            fillColor: 'rgba(59, 191, 243, 0.5)',
                                            borderWidth: 2,
                                            pointBackgroundColor: '#3dbff3',
                                            pointBorderColor: '#ffffff',
                                            pointRadius: 4,
                                            tension: 0.4,
                                            borderColor: '#3dbff3',
                                        },
                                        {
                                            data: [15, 10, 30, 15, 12, 10, 20, 15, 25, 20,],
                                            label: 'New Users',
                                            color: '#e57463',
                                            fillColor: 'rgba(229, 116, 99, 0.5)',
                                            borderWidth: 2,
                                            pointBackgroundColor: '#e57463',
                                            pointBorderColor: '#ffffff',
                                            pointRadius: 4,
                                            tension: 0.4,
                                            borderColor: '#e57463',
                                        },
                                        {
                                            data: [20, 15, 15, 10, 20, 15, 25, 20, 10, 30],
                                            label: 'Clients',
                                            color: '#00c851',
                                            fillColor: 'rgba(0, 200, 81, 0.5)',
                                            borderWidth: 2,
                                            pointBackgroundColor: '#00c851',
                                            pointBorderColor: '#ffffff',
                                            pointRadius: 4,
                                            tension: 0.4,
                                            borderColor: '#00c851',
                                        },
                                    ]}
                                    scalesx={true}
                                    scalesy={true}
                                    height={210} />
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3">
                                    <div className="col-6 col-lg-3 mb-3 mb-lg-0">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-50 rounded bg-theme-1-subtle text-theme-1 theme-cyan">
                                                    <i className="bi bi-briefcase h5"></i>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <p className="small text-secondary mb-1">Total Jobs</p>
                                                <h4>7258</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-3 mb-3 mb-lg-0">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-50 rounded bg-theme-1-subtle text-theme-1 theme-green">
                                                    <i className="bi bi-buildings h5"></i>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <p className="small text-secondary mb-1">Employers</p>
                                                <h4>1315</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-3">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-50 rounded bg-theme-1-subtle text-theme-1 theme-red">
                                                    <i className="bi bi-people h5"></i>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <p className="small text-secondary mb-1">Users</p>
                                                <h4>25850</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header border-0 text-right">
                                <h6 className="mb-1">Top Employer</h6>
                                <p className="text-secondary small">Top hiring by company</p>
                            </div>
                            <div className="card-body text-center pt-2 ">
                                <figure className="avatar avatar-150 rounded-circle mb-3 mb-lg-4">
                                    <img src={asset('assets/img/adminuiux/user-9.jpg')} alt="" />
                                </figure>
                                <h5 className="mb-0">DevUIUX</h5>
                                <p className="text-secondary small">HR Manager</p>
                            </div>
                            <div className="card-footer border-top py-0">
                                <div className="row gx-4">
                                    <div className="col py-3">
                                        <p className="text-secondary small mb-1">Job Posted</p>
                                        <h5 className="">700</h5>
                                    </div>
                                    <div className="col-auto px-0 border-start"></div>
                                    <div className="col border-left py-3">
                                        <p className="text-secondary small mb-1">Total Hiring</p>
                                        <h5 className="">568</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* divider card */}
                <div className="card bg-theme-l-gradient mb-3 mb-lg-4">
                    <div className="card-body">
                        <div className="row gx-3 gx-lg-4 align-items-center">
                            <div className="col-12 col-md-auto align-self-center mb-3 mb-md-0">
                                <figure className="avatar avatar-60 rounded"><img src={asset('assets/img/adminuiux/user-9.jpg')} alt="" /></figure>
                            </div>
                            <div className="col-12 col-md mb-3 mb-md-0">
                                <h5 className="mb-1">DevUIUX did amazing job in recuriment filed.</h5>
                                <p className="opacity-75">It granted for nomination of the best company.</p>
                            </div>
                            <div className="col-12 col-md-auto align-self-center">
                                <button className="btn btn-link text-white">View all Badges</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* employers events */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center">
                                        <figure className="avatar avatar-90 rounded"><img src={asset('assets/img/adminuiux/user-2.jpg')} alt="" /></figure>
                                    </div>
                                    <div className="col">
                                        <h4>568 <small className="">Jobs</small></h4>
                                        <p className="mb-1">Manisha Srivastav</p>
                                        <p className="text-secondary small">HR Manager, CapcupTech</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center">
                                        <figure className="avatar avatar-90 rounded"><img src={asset('assets/img/adminuiux/user-6.jpg')} alt="" /></figure>
                                    </div>
                                    <div className="col">
                                        <h4 className="">105 <small>Referrals</small></h4>
                                        <p className="mb-1">Jainny Goel</p>
                                        <p className="text-secondary small"><i className="bi bi-star-fill text-warning"></i> Top rated user</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <h6 className="mb-0">Walk-in Drive, TCSO, SV, USA</h6>
                                <p className="text-secondary"><small>Thursday, 10-5-2026</small></p>
                                <div className="row gx-3">
                                    <div className="col">
                                        <span className="avatar avatar-30 rounded bg-theme-1-subtle text-theme-1"><i className="bi bi-calendar-event"></i></span>
                                    </div>
                                    <div className="col-auto">
                                        <figure className="avatar avatar-30 coverimg rounded"><img src={asset('assets/img/adminuiux/user-2.jpg')} alt="" /></figure>
                                        <figure className="avatar avatar-30 coverimg rounded"><img src={asset('assets/img/adminuiux/user-6.jpg')} alt="" /></figure>
                                        <figure className="avatar height-30 w-auto bg-theme-1-subtle text-theme-1 px-2 small rounded theme-pink">+1.1k</figure>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-theme btn-sm">Apply</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* open jobs */}
                <div className="card mb-3 mb-lg-4">
                    <div className="card-header">
                        <div className="row gx-3 gx-lg-4 align-items-center">
                            <div className="col-12 col-md mb-3 mb-md-0">
                                <h6 className="mb-1">Openings</h6>
                                <p className="text-secondary small">Jobs from the network clients </p>
                            </div>
                            <div className="col col-md-auto">
                                <div className='input-group'>
                                    <input type="text" className="form-control" placeholder="Search" onChange={(e) => dtApi?.search(e.target.value).draw()} />
                                    <span className="input-group-text"><i className="bi bi-search"></i></span>
                                </div>
                            </div>
                            <div className="col-auto">
                                <button className="btn btn-sm btn-theme-1" data-bs-toggle="tooltip" title="Download"><i className="bi bi-download"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-0">
                        <DataTable className="table mb-3" options={options}>
                            <thead>
                                <tr>
                                    <th>Job Title</th>
                                    <th className="desktop">Company</th>
                                    <th className="tablet desktop">Experience</th>
                                    <th className="none">Posting Date</th>
                                    <th className="tablet desktop">Last Date</th>
                                    <th className="tablet desktop">Status</th>
                                    <th className="tablet desktop">Applicants</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobsData.map((job, index) => (
                                    <tr key={index}>
                                        <td>
                                            <h6 className="mb-1">{job.title}</h6>
                                            <p className="text-secondary small">{job.location}</p>
                                        </td>
                                        <td>{job.company}</td>
                                        <td>{job.experience}</td>
                                        <td>{job.postingDate}</td>
                                        <td className="text-theme-1 theme-red">{job.lastDate}</td>
                                        <td><span className={`badge badge-light rounded text-bg-theme-1 ${job.statusClass}`}>{job.status}</span></td>
                                        <td>{job.applicants}</td>
                                        <td><button className="btn btn-link btn-square theme-red"><i className={`bi bi-heart${job.isFavorite ? '-fill' : ''}`}></i></button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </DataTable>

                    </div>
                </div>
            </div>


            <MobileFooter />
        </>
    );
};

export default JobPortal;
